import axiosInstance from '@/axiosInstance';
import type { AxiosResponse } from 'axios';
import type { Customer } from './types';

export type { Customer } from './types';

export const CustomerAPI = {
  async getCustomers(): Promise<AxiosResponse<Customer[]>> {
    try {
      const response = await axiosInstance.get(`/api/Customer/`);
      return response;
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw error;
    }
  },
};
